import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { GET_COMPLETED_ITEMS, GET_SETTINGS, GET_STORE_ITEMS } from '../../../constants/endpoints';
import { useParams } from 'react-router-dom';
import Loader from '../../../shared/loader/loader';
import FeatureBadge from '../../../shared/badge/badge';
import { ENVIRONMENT_CONSTANT } from '../../../constants/env.constant';
import "./store.scss";
import { getTextColorByBG, getBgColor } from '../../../utils/utils';
import SmallCampaignTiles from './small-campaign-tiles';

function MasjidStoreCopy(props) {

    const logoBaseUrl = ENVIRONMENT_CONSTANT.LOGO_BASE_URL;
    const campaignIconUrl = ENVIRONMENT_CONSTANT.CAMPAIGN_ICON_URL;
    const param = useParams();
    const shortCode = param?.short_code;
    const type = param?.type;

    const itemTypes = [
        { label: 'All', value: '' },
        { label: 'Campaigns', value: 'campaign' },
        { label: 'Products', value: 'product' }
    ];

    // const [type, setType] = useState('product');
    const [searchText, setSearchText] = useState('');
    const [requestLoader, setRequestLoader] = useState(false);
    const [storeItems, setStoreItems] = useState([]);
    const [organizationInfo, setOrganizationInfo] = useState({});
    const [featuredItems, setFeaturedItems] = useState([]);
    const [completedItems, setCompletedItems] = useState([]);
    const [pageSettings, setPageSettings] = useState({});

    const getStoreItems = (masjidID) => {
        setRequestLoader(true);
        const body = {
            type: type ? type : 'both'
        }
        axios.post((GET_STORE_ITEMS + masjidID), body)
            .then((res) => {
                setRequestLoader(false);
                if (res?.data?.status) {
                    const items = res?.data?.response?.items;
                    let featuredItems = [];
                    let allItems = []
                    for (let index = 0; index < items.length; index++) {
                        if(items[index].feature_campaign){
                            featuredItems.push(items[index])
                        }else{
                            allItems.push(items[index])
                        }
                    }

                    setFeaturedItems(featuredItems);
                    setStoreItems(allItems);
                    setOrganizationInfo(res?.data?.response?.organization);
                }
            }).catch((error) => {
                setRequestLoader(false);
            })
    }

    const getCompletedItems = (masjidID) => {
        const body = {
            type: type ? type : 'both'
        }
        axios.post((GET_COMPLETED_ITEMS + masjidID), body)
            .then((res) => {
                setRequestLoader(false);
                if (res?.data?.status) {
                    setCompletedItems(res?.data?.response)
                }
            }).catch((error) => {
                setRequestLoader(false);
            })
    }

    const getPageSettings = () => {
        axios.get(`${GET_SETTINGS}${shortCode}/${type ? type : 'both'}`)
        .then((res) => {
            if(res?.data?.status){
                setPageSettings(res?.data?.response);
                getStoreItems(res?.data?.response?.masjid_id);
                getCompletedItems(res?.data?.response?.masjid_id);
            }
        }).catch((error) => {

        })
    }

    useEffect(() => {
        getPageSettings();
    }, [])

    //return footer
    const footer = () => {
        return <div className="foot">
            <a href="https://masjidal.com" target="_blank" rel="noreferrer">
                <img src='/img/masjid/masjidal-logo-new.png' alt="Masjidal" />
            </a>
            <span>Powered by <a href="https://masjidal.com" target="_blank" rel="noreferrer">Masjidal</a></span>
        </div>
    }

    const formatCurrency = (value) => {
        const amount = Number(value || 0);
        return `$${amount.toLocaleString()}`;
    }

    const getFeaturedImageUrl = (item) => {
        return item?.image_location ? `${logoBaseUrl}${item.image_location}` : null;
    }

    const getRaisedAmount = (item) => {
        return Number(item?.raised_amount || 0);
    }

    const getGoalAmount = (item) => {
        return Number(item?.goal_amount || 0);
    }

    const getFundedPercent = (item) => {
        const goalAmount = getGoalAmount(item);
        if (!goalAmount) return 0;
        return Math.min(Math.round((getRaisedAmount(item) / goalAmount) * 100), 100);
    }

    return (
        <div className="masjid-store-page-wrapper"
          style={{
            '--primary-color': pageSettings?.primary_color ? pageSettings?.primary_color : '#004475',
            background: `linear-gradient(180deg, ${getBgColor(pageSettings?.primary_color)} 0%, #ffffff 280px)`,
            
            minHeight: '100vh'
          }}>
            {/* main banner content start */}
            <div  className='masjid-banner-image position-relative d-sm-none d-none d-md-block' 
            style={{
                background:`url(${pageSettings?.image_location ? (logoBaseUrl + pageSettings?.image_location) : ''}) no-repeat top center`
            }}
            >
                <div className='container'>

                    <div>
                        {pageSettings?.is_display_logo && organizationInfo?.image_location ? 
                    <div className='text-center pt-4'>
                        <img
                            style={{
                                maxHeight: '120px',
                                maxWidth: '100%',
                                width: '100px'
                            }}
                            src={`${logoBaseUrl}${organizationInfo?.image_location}`}
                            alt="Organization Logo"
                        />
                    </div> : ''
             }   
                        <div className='position-relative'>
                        {/* {
                            organizationInfo?.website && !pageSettings?.hide_back_link ?
                                <a style={{
                                    color: pageSettings?.main_text_color ? pageSettings?.main_text_color : 'white',
                                    top:'10%'
                                }} href={organizationInfo?.website} target='_self' 
                                className='d-md-block d-none text-xl-start position-absolute'>
                                    <i className="fa-solid fa-arrow-left"></i> Back to {organizationInfo?.organization_name ? organizationInfo?.organization_name : 'Masjid - Site'}
                                </a> : ''
                        } */}

                        {/* {
                            pageSettings?.is_display_logo && organizationInfo?.image_location ? 
                            <div className='text-center mt-1'>
                            <img
                                style={{
                                    maxHeight: '120px',
                                    maxWidth: '100%'
                                }}
                                src={`${logoBaseUrl}${organizationInfo?.image_location}`} />
                        </div> : ''
                        } */}
                        </div>
                      

                        {/* {src={`${logoBaseUrl}${organizationInfo?.image_location}`}
                            pageSettings?.is_display_logo && organizationInfo?.image_location ? 
                            <hr className='mt-5' /> : ''
                        } */}
                        
                        <div className='banner-description pt-2'>
                            <h1 style={{
                                color: pageSettings?.main_text_color ? pageSettings?.main_text_color : 'black'
                            }}>{pageSettings?.title ? pageSettings?.title : 'Make A Donation'}</h1>

                            <p
                            style={{
                                color: pageSettings?.main_text_color ? pageSettings?.main_text_color : 'black'
                            }}
                             className='mb-4 px-md-2 px-sm-3 '>{pageSettings?.description ? pageSettings?.description : 'The Prophet ﷺ said: "Whoever builds a masjid for Allah, Allah will build for him a similar house in Jannah” (Sahih Muslim).'}</p>
                        </div>
                    </div>

                </div>
            </div>
            {/* main banner content end */}

            <div className='masjid-banner-image position-relative d-sm-block d-block d-md-none ' 
            style={{
                '--primary-color': pageSettings?.primary_color ? pageSettings?.primary_color : '#004475',
                // backgroundColor: pageSettings?.primary_color ? pageSettings?.primary_color : '#004475',
                minHeight: '100vh',
                // backgroundColor: pageSettings?.secondary_color ? pageSettings?.secondary_color : '#daeffffa',
                minHeight:pageSettings?.hide_subtitle_on_mobile ? '0px' : '220px',
                paddingTop: '10px', 
                // paddingBottom: '20px' 
            }}
            >
                <div className='container pb-0'>

                    <div>
                        {
                            organizationInfo?.website && !pageSettings?.hide_back_link ?
                                <a style={{
                                    color: pageSettings?.main_text_color ? pageSettings?.main_text_color : 'white',
                                }} href={organizationInfo?.website} target='_self' 
                                className='d-md-block d-none text-white pt-3 text-xl-start'>
                                    <i className="fa-solid fa-arrow-left"></i> Back to {organizationInfo?.organization_name ? organizationInfo?.organization_name : 'Masjid - Site'}
                                </a> : ''
                        }
                            <div className='text-center '>
                            <img
                                style={{
                                    maxHeight: '80px',
                                    maxWidth: '80%'
                                }}
                                src={`${logoBaseUrl}${organizationInfo?.image_location}`} />                         
                        </div>
                        
                        <div className=' banner-description w-100 mt-4' >
                            <h5 style={{
                                color:  pageSettings?.secondary_color ? getTextColorByBG(pageSettings?.secondary_color) : '#004475'
                            }}>{pageSettings?.title ? pageSettings?.title : 'Make A Donation'}</h5>
                            <p
                            style={{
                                color:  pageSettings?.secondary_color ? getTextColorByBG(pageSettings?.secondary_color) : '#004475',
                                fontSize:'0.9rem'
                            }}
                             className={`${pageSettings?.hide_subtitle_on_mobile ? 'd-none d-md-block' : ''} mb-3 px-md-2 px-sm-3 px-3`}>{pageSettings?.description ? pageSettings?.description : 'The Prophet ﷺ said: "Whoever builds a masjid for Allah, Allah will build for him a similar house in Jannah” (Sahih Muslim).'}</p>
                        </div>
                    </div>

                </div>
            </div>

            {/* featured campaign/products start */}
           {
                featuredItems?.length > 0 ?
                <div className='container featured-section'>
                <div>
                    {
                        featuredItems?.map((item, index) => {
                            const featuredImageUrl = getFeaturedImageUrl(item);
                            const hasFeaturedImage = Boolean(featuredImageUrl);
                            const goalAmount = getGoalAmount(item);
                            const raisedAmount = getRaisedAmount(item);
                            const fundedPercent = getFundedPercent(item);
                            return  <div key={`featured_item_${index}`}>
                            {index > 0 ? <div className='mt-5' >  </div> : ''}
                              <div className={`featured-campaign ${hasFeaturedImage ? 'has-image' : 'no-image'}`} style={{ '--primary-color': pageSettings?.button_color || '#004475' }}>

                        {hasFeaturedImage ? <div className='f-img-col'>
                            <img src={featuredImageUrl} alt={item?.campaign_title || 'Featured campaign'} />
                        </div> : ''}

                        <div className='f-content-col'>
                            <div className='featured-card-topline'>
                                <span className='featured-label'>Featured</span>
                                {
                                    item?.type === 'product' ? (
                                        (item?.remainingQuantity || item?.remaining_quantity || item?.quantity || item?.remaining_qty) ? (
                                            <span className='remaining-quantity'>
                                                {item?.remainingQuantity ?? item?.remaining_quantity ?? item?.quantity ?? item?.remaining_qty} left
                                            </span>
                                        ) : ''
                                    ) : (
                                        goalAmount > 0 ? (
                                            <span className='remaining-quantity'>Goal: {formatCurrency(goalAmount)}</span>
                                        ) : ''
                                    )
                                }
                            </div>
                            <h2 className='featured-product-title'>{item.campaign_title}</h2>
                            <span className='featured-description d-block'>{item.featured_campaign_desc}</span>
                            <div className='featured-card-actions'>
                                            <a style={{
                                                    backgroundColor: pageSettings?.button_color ? pageSettings?.button_color : '#004475',
                                                    color: getTextColorByBG(pageSettings?.button_color ? pageSettings?.button_color : '#004475')
                                                }} target='_blank'
                                                href={
                                                    item?.type === 'product' ?
                                                        `
                                                            ${organizationInfo?.organization_short_name ?
                                                            organizationInfo?.organization_short_name : 'masjid'
                                                        }/product/${item.donation_page_link}` : `${organizationInfo?.organization_short_name ?
                                                            organizationInfo?.organization_short_name : 'masjid'
                                                        }/campaign/${item.donation_page_link}`
                                                }
                                                className={`btn btn-primary ${item.type === 'product' ? 'mx-1' : ''} m-0 donate-now`}>{item?.change_label_to_pay ? 'Pay' : 'Donate Now'}</a>
                                               {item?.type === 'product' ? (
                                                   <div className='d-flex align-items-baseline gap-1 ms-2'>
                                                       <h4 className='featured-price text-black mb-0'>{formatCurrency(item?.price_per_unit / 100)}</h4>
                                                       {item?.unit_label && (
                                                           <span className='product-small-tile-unit' style={{ fontSize: '13px', fontWeight: '500', color: '#888' }}>
                                                               {item.unit_label.toLowerCase().startsWith('per') ? item.unit_label.toLowerCase() : `per ${item.unit_label.toLowerCase()}`}
                                                           </span>
                                                       )}
                                                   </div>
                                               ) : ''}
                                                {/* {item?.type !== 'product' && goalAmount > 0 ? <div className='featured-progress-wrap'>
                                                    <div className='featured-progress'>
                                                        <span style={{ width: `${fundedPercent}%` }}></span>
                                                    </div>
                                                    <div className='featured-progress-amounts'>
                                                        <strong>{formatCurrency(raisedAmount)}</strong>
                                                        <span>of {formatCurrency(goalAmount)}</span>
                                                    </div>
                                                </div> : ''} */}
                                          </div>

                        </div>
                              </div>
                        </div>
                        })
                    }

                </div>

            </div> : ''
           }
            {/* featured campaign/products end */}

            {/* campaign or products start */}
            <div
            style={{
                // '--primary-color': pageSettings?.primary_color ? pageSettings?.primary_color : '#004475'
            }}
            // className={`campaign-main-section d-sm-none d-none d-md-block pt-5 ${completedItems?.length > 0 ? 'pb-7' : ''}`}>
             className={`campaign-main-section d-sm-none d-none d-md-block  ${completedItems?.length > 0 ? 'pb-5' : ''}`}>
                <div className='container'>
                    <div className='row justify-content-center'>          
                        {
                            storeItems?.map((item, index) => {
                                return <div key={`item_${index}`} className={`col-lg-4 col-md-6 ${featuredItems?.length > 0 ? 'mt-6' : 'pt-4'}`}>
                                <div className='product' style={{
                                    // backgroundColor: pageSettings?.primary_color ? pageSettings?.primary_color : '#004475'
                                    '--primary-color': pageSettings?.button_color ? pageSettings?.button_color : '#004475'
                                }}>
                                    <div>
                                        <div className='d-flex justify-content-between align-items-center' style={{minHeight:'23px'}}>
                                            <div>
                                            {/* <img className='image-icon store-img' src={item?.campaign_icon ? (campaignIconUrl + item.campaign_icon) : '/img/masjid/mosque.png'} /> */}
                                            </div>
                                            <div>
                                            {
                                              item?.type === 'product' ? (
                                                  (item?.reset_count?.toLowerCase() !== 'yearly' && item?.reset_count?.toLowerCase() !== 'monthly' && (item?.remainingQuantity || item?.quantity || item?.remaining_quantity)) ? (
                                                      <span style={{
                                                          color: pageSettings?.secondary_color ? getTextColorByBG(pageSettings?.secondary_color) : '#004475',
                                                          backgroundColor: pageSettings?.secondary_color ? pageSettings?.secondary_color : '#DAEFFF'
                                                      }} className='remaining-quantity'>
                                                          {item?.remainingQuantity ?? item?.quantity ?? item?.remaining_quantity} left
                                                      </span>
                                                  ) : ''
                                              ) : (
                                                  Number(item?.goal_amount) > 0 ? (
                                                      <span style={{
                                                          color: pageSettings?.secondary_color ? getTextColorByBG(pageSettings?.secondary_color) : '#004475',
                                                          backgroundColor: pageSettings?.secondary_color ? pageSettings?.secondary_color : '#DAEFFF'
                                                      }} className='remaining-quantity'>
                                                          Goal: {formatCurrency(item?.goal_amount)}
                                                      </span>
                                                  ) : ''
                                              )
                                            }
                                            </div>
                                        </div>
                                        <div className='card-section'>
                                            <div
                                            style={{
                                                // minHeight:'50px',
                                                minHeight:'30px',
                                                maxHeight:'40px', 
                                            }}
                                            className='mt-2 card-title'>{item?.campaign_title}</div>
                                            <p
                                            style={{
                                                minHeight:'40px',
                                                overflow:'hidden',
                                                display:'-webkit-box',
                                                WebkitLineClamp:2,
                                                WebkitBoxOrient:'vertical',
                                                textOverflow:'ellipsis',
                                                // color: pageSettings?.primary_color ? getTextColorByBG(pageSettings?.primary_color) : 'white'
                                            }}
                                             className='mb-0 pt-0'>{item?.subtitle}</p>
                                             {item?.type === 'product' ? (
                                                  <div className='card-price mt-4 mb-0'>
                                                      <span className='card-price-val'>${item?.price_per_unit / 100}</span>
                                                      {item?.unit_label && (
                                                          <span className='card-price-unit product-small-tile-unit'>
                                                              {item.unit_label.toLowerCase().startsWith('per') ? item.unit_label.toLowerCase() : `per ${item.unit_label.toLowerCase()}`}
                                                          </span>
                                                      )}
                                                  </div>
                                              ) : null}
                                        </div>
                                    </div>
                                    <div className='donate'>
                                        <a style={{
                                    backgroundColor: pageSettings?.button_color ? pageSettings?.button_color : '#004475',
                                    color: pageSettings?.primary_color ? getTextColorByBG(pageSettings?.primary_color) : 'white',
                                    "--btn-color": pageSettings?.button_color || "#004475",

                                }} target='_blank'
                                                    href={
                                                        item?.type === 'product' ?
                                                            `
                                                                ${organizationInfo?.organization_short_name ?
                                                                organizationInfo?.organization_short_name : 'masjid'
                                                            }/product/${item.donation_page_link}` : `${organizationInfo?.organization_short_name ?
                                                                organizationInfo?.organization_short_name : 'masjid'
                                                            }/campaign/${item.donation_page_link}`
                                                    }
                                                    className={`btn  w-100 m-0 donate-now`}>{item?.change_label_to_pay ? 'Pay' : 'Donate'}</a>
                                    </div>
                                </div>
                            </div>
                            })
                        }
                    </div>
                </div>

                {
                    completedItems?.length === 0 && storeItems?.length > 0 ?
                    footer() : ''
                }
            </div>
            {/* campaign or products end */}
            {/* campaign tile section for small screens */}
           <SmallCampaignTiles
           campaignIconUrl={campaignIconUrl}
           logoBaseUrl={logoBaseUrl}
           completedItems={completedItems}
           footer={footer}
           storeItems={storeItems}
           featuredItems={featuredItems} 
           pageSettings={pageSettings}
           organizationInfo={organizationInfo} />
           {/* campaign tile section for small screens end */}

            {/* completed products/campaigns start */}
                <div className='masjid-bottom-banner position-relative'>
            {/* <div>
            <img className='position-absolute' src='/img/masjid/public-pages/frame-left.png' />
            <img className='position-absolute img-hh' src='/img/masjid/public-pages/frame-right.png' />
            </div> */}
                {/* {
                    completedItems?.length > 0 ?
                    <>
                    <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='text-center pt-0'>
                            <h4 style={{
                                    color: "#111111"
                                }} className='text-capitalize'>Completed {!type ? 'Campaigns / Products' : type+'s'}</h4>
                        </div>

                        tiles start
                        {
                        completedItems.map((item, index) => {
                            return  <div key={`completed_item_${index}`} className='d-sm-none d-none d-md-block col-xxl-3 col-lg-4 col-md-4 mt-5'>
                            <div className='product completed ' style={{
                                '--primary-color': pageSettings?.button_color ? pageSettings?.button_color : '#004475'
                            }}>
                                <div>
                                    <div className='d-flex justify-content-between'>
                                        <div></div>
                                        <div>
                                            <span style={{'--btn-color': pageSettings?.button_color ? pageSettings?.button_color : '#004475'}} className='completed-quantity '>Completed</span>
                                        </div>
                                    </div>
                                    <h5
                                    style={{
                                        maxHeight:'50px',
                                        minHeight:'40px',
                                        overflow:'hidden'
                                    }}
                                    className='mt-2 card-title'>{item?.campaign_title}</h5>
                                    <p
                                    style={{
                                        minHeight:'40px',
                                        overflow:'hidden',
                                        display:'-webkit-box',
                                        WebkitLineClamp:2,
                                        WebkitBoxOrient:'vertical',
                                        textOverflow:'ellipsis',
                                        lineHeight:'1.5'
                                    }}
                                    className='mb-0 pt-0'>{item?.subtitle}</p>
                                </div>
                                <hr className='mx-3 mb-0' />
                                <div className='f-18 text-center completed-campaign py-3 mb-0'>
                                    Completed
                                </div>
                            </div>
                        </div>
                        })
                        }

                        tiles end
                        <SmallCampaignTiles
                completedCampaigns={true}
                campaignIconUrl={campaignIconUrl}
                completedItems={completedItems}
                footer={footer}
                storeItems={completedItems}
                featuredItems={featuredItems} 
                pageSettings={pageSettings}
                organizationInfo={organizationInfo} />
                    </div>
                </div>
                    </> : ''
                } */}

            {
                completedItems?.length > 0 ?
                footer() : ''
            }
            </div> 
            
            {/* completed products/campaigns end */}
        </div>
    );
}

export default MasjidStoreCopy;